import { createSlice } from '@reduxjs/toolkit';

// Not persisted, so a tour closed with Esc comes back on the next visit.
const initialState = {
    isDismissed: false,
};

export const sidebarTourSlice = createSlice({
    name: 'sidebarTour',
    initialState,
    reducers: {
        dismissSidebarTour: (state) => {
            state.isDismissed = true;
        },
        resetSidebarTourDismissal: (state) => {
            state.isDismissed = false;
        },
    },
});

export const { dismissSidebarTour, resetSidebarTourDismissal } = sidebarTourSlice.actions;

export default sidebarTourSlice.reducer;
